import { useEffect } from "react";

import * as Sentry from "@sentry/react";
import { useAuthStorage } from "@bridgesplit/abf-react";

/**
 * Syncs wallet address with Sentry user context for tracking
 * This allows us to see which deployment a specific user was on when they report issues
 */
export const useSentryUser = () => {
    const { state } = useAuthStorage();
    const walletAddress = state.stateWalletAddress;
    const walletClientType = state.walletClientType;

    useEffect(() => {
        if (walletAddress) {
            // Set Sentry user context when wallet is connected
            Sentry.setUser({
                id: walletAddress,
                username: walletAddress.slice(0, 8) + "..." + walletAddress.slice(-6),
                wallet_type: walletClientType || "unknown"
            });
        } else {
            // Clear user context when wallet is disconnected
            Sentry.setUser(null);
        }
    }, [walletAddress, walletClientType]);
};
